import { createFileRoute } from '@tanstack/react-router'
import SupplierListPageHeader from '../../Pages/SupplierListPage/SupplierListPageHeader'
import SupplierListPage from '../../Pages/SupplierListPage/SupplierListPage'
import PageBody from '../../Pages/Layout/PageBody'
import LoadingSpinner from '../../Components/LoadingSpinner'
import ErrorComponent from '../../Components/ErrorComponent'
import {
    canViewRoute,
    migratedToV2,
} from '../../State/Permissions/HasPermissions'
import SessionStore from '../../State/SessionStore'
import PermissionDenied from '../../Pages/PermissionDenied'
import { setLayoutDefaults } from '@2/layout/layout-store'
import { CenterPadPageBody } from '@2/layout/page-body'
import { trpc } from '../../system/trpc'
import { processTRPCData } from '../../Queries/fetchData'

export const Route = createFileRoute('/_private/suppliers')({
    beforeLoad: ({ params }) => {
        if (!canViewRoute(SessionStore.user, 'suppliers', params))
            throw new Error('Permission Denied')
        setLayoutDefaults({
            pageTitle: 'Suppliers',
            subMenu: 'suppliers',
        })
    },
    errorComponent: ({ error, reset }) => {
        if (error.message === 'Permission Denied') return <PermissionDenied />
        return <ErrorComponent error={error} reset={reset} />
    },
    loader: async () => await loader(),
    pendingComponent: LoadingSpinner,
    component: Wrapper,
})

const loader = async () => {
    const data = await trpc.legacy.getSuppliersPageData.query()
    return processTRPCData(data)
}

function Wrapper() {
    if (migratedToV2()) {
        return (
            <CenterPadPageBody>
                <SupplierListPage />
            </CenterPadPageBody>
        )
    }
    return (
        <>
            <SupplierListPageHeader />
            <PageBody>
                <SupplierListPage />
            </PageBody>
        </>
    )
}
